import React from 'react'
import ReactDOM from 'react-dom/client'
import Nots from './notes/Nots'
import './Allnotsh.css'




export default function Allnotsh() {
  return (
    <div>
          
      <Nots />
    </div>
  )
}


